const TRANSLATION = {
  APP_NAMESPACE: 'App',
  REDUCER_KEY: 'language',
} as const;

export default TRANSLATION;
